var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "12",
        height: "13",
        viewBox: "0 0 12 13",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("title", [_vm._v("Icon / View Edit")]),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M11.4268 1.07225C11.5244 1.16988 11.5244 1.32817 11.4268 1.4258L5.92678 6.9258C5.82915 7.02343 5.67085 7.02343 5.57322 6.9258C5.47559 6.82817 5.47559 6.66988 5.57322 6.57225L11.0732 1.07225C11.1709 0.974616 11.3291 0.974616 11.4268 1.07225Z",
          fill: "currentColor",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M7 1.24902C7 1.11095 7.11193 0.999023 7.25 0.999023H11.25C11.3881 0.999023 11.5 1.11095 11.5 1.24902V5.24902C11.5 5.38709 11.3881 5.49902 11.25 5.49902C11.1119 5.49902 11 5.38709 11 5.24902V1.49902H7.25C7.11193 1.49902 7 1.38709 7 1.24902Z",
          fill: "currentColor",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M0.866116 2.86514C1.10054 2.63072 1.41848 2.49902 1.75 2.49902H4.75C4.88807 2.49902 5 2.61095 5 2.74902C5 2.88709 4.88807 2.99902 4.75 2.99902H1.75C1.55109 2.99902 1.36032 3.07804 1.21967 3.21869C1.07902 3.35935 1 3.55011 1 3.74902V10.749C1 10.9479 1.07902 11.1387 1.21967 11.2794C1.36032 11.42 1.55109 11.499 1.75 11.499H8.75C8.94891 11.499 9.13968 11.42 9.28033 11.2794C9.42098 11.1387 9.5 10.9479 9.5 10.749V7.74902C9.5 7.61095 9.61193 7.49902 9.75 7.49902C9.88807 7.49902 10 7.61095 10 7.74902V10.749C10 11.0805 9.8683 11.3985 9.63388 11.6329C9.39946 11.8673 9.08152 11.999 8.75 11.999H1.75C1.41848 11.999 1.10054 11.8673 0.866116 11.6329C0.631696 11.3985 0.5 11.0805 0.5 10.749V3.74902C0.5 3.4175 0.631696 3.09956 0.866116 2.86514Z",
          fill: "currentColor",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M11.4414 0.786963C11.4999 0.811183 11.5548 0.846999 11.6025 0.894411L11.6036 0.89547C11.7 0.991927 11.7488 1.11799 11.75 1.24441C11.75 1.24594 11.75 1.24748 11.75 1.24902C11.7499 1.37682 11.7011 1.50507 11.6036 1.60258L10.75 2.45613L11.6025 0.894411L10.0429 1.74902L10.8838 1.28824C10.9814 1.19064 11.122 0.749055 11.2499 0.749023H7.25C6.97386 0.749023 6.75 0.972882 6.75 1.24902C6.75 1.52517 6.97386 1.74902 7.25 1.74902H10.0429L5.39645 6.39547C5.20118 6.59073 5.20118 6.90731 5.39645 7.10258C5.59171 7.29784 5.90829 7.29784 6.10355 7.10258L10.75 2.45613V5.24902C10.75 5.52517 10.9739 5.74902 11.25 5.74902C11.5261 5.74902 11.75 5.52517 11.75 5.24902V1.24902M11.4414 0.786963C11.3824 0.762516 11.3177 0.749023 11.2499 0.749023L11.4414 0.786963ZM0.68934 2.68836C0.970644 2.40706 1.35218 2.24902 1.75 2.24902H4.75C5.02614 2.24902 5.25 2.47288 5.25 2.74902C5.25 3.02517 5.02614 3.24902 4.75 3.24902H1.75C1.61739 3.24902 1.49021 3.3017 1.39645 3.39547C1.30268 3.48924 1.25 3.61641 1.25 3.74902V10.749C1.25 10.8816 1.30268 11.0088 1.39645 11.1026C1.49022 11.1963 1.61739 11.249 1.75 11.249H8.75C8.88261 11.249 9.00978 11.1963 9.10355 11.1026C9.19732 11.0088 9.25 10.8816 9.25 10.749V7.74902C9.25 7.47288 9.47386 7.24902 9.75 7.24902C10.0261 7.24902 10.25 7.47288 10.25 7.74902V10.749C10.25 11.1469 10.092 11.5284 9.81066 11.8097C9.52936 12.091 9.14783 12.249 8.75 12.249H1.75C1.35217 12.249 0.970644 12.091 0.68934 11.8097C0.408035 11.5284 0.25 11.1468 0.25 10.749V3.74902C0.25 3.3512 0.408035 2.96967 0.68934 2.68836Z",
          fill: "currentColor",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M11.2461 0.74707L10.5 0.999023L10.75 1.99902V2.49902L11.5 2.24902L11.7363 1.48926L11.75 1.24902L11.5977 0.895508L11.4316 0.78418L11.2461 0.74707Z",
          fill: "currentColor",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }